var productsCarousel = {
    init: function(target) {
        $slider = $(target);
        $slider.slick({
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            arrows: false,
            responsive: [

              {
                    breakpoint: 1740,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,

                    }
                  },
                {
                    breakpoint: 1440,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,

                    }
                  },
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    }
                  },
                  {
                  breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                  breakpoint: 420,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }                 
                ]
        });
       $('.olive-products .controls .arrow-left').click(function () {
            $slider.slick('slickPrev');
            return false;
        });
        
         $('.olive-products .controls .arrow-right').click(function () {
            $slider.slick('slickNext');
            return false;
        });

  }
}

var productsHoneyCarousel = {
    init: function(target) {
        $_slider = $(target);
        $_slider.slick({
            lazyLoad: 'ondemand',
             slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1740,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,

                    }
                  },
                   {
                    breakpoint: 1440,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,

                    }
                  },
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    }
                  },
                   {
                    breakpoint: 992,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    }
                  },
                  {
                  breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                  breakpoint: 420,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }                 
                ]
        });
      $('.honey-products .controls .arrow-left').click(function () {
            $_slider.slick('slickPrev');
            return false;
        });
       
         $('.honey-products .controls .arrow-right').click(function () {
            $_slider.slick('slickNext');
            return false;
        });

  }
}



